// Playback URLs for a TRANSCODE action live in its AWSJSON config and are generated by the
// backend when the event starts - before that the action has no destinationUrls at all.
// Shape: { transcoding: { destinationUrls: ["https://.../index.m3u8", ...] } }
export function getTranscodeDestinationUrls(action) {
  const rawConfig = action && action.config;
  if (!rawConfig) return [];

  let config = rawConfig;
  if (typeof rawConfig === 'string') {
    try {
      config = JSON.parse(rawConfig);
    } catch (error) {
      return [];
    }
  }

  const urls = config && config.transcoding && config.transcoding.destinationUrls;
  return Array.isArray(urls) ? urls.filter((url) => typeof url === 'string' && url.trim() !== '') : [];
}
